// extracted by mini-css-extract-plugin
module.exports = {"selectorWrp":"styles_selectorWrp__1xPOE","loaderWrp":"styles_loaderWrp__Xwe7k"};